const STORAGE_KEY_CAJA_ID = "selected_caja_id";

export const getSelectedCajaId = (fallback = 1) => {
  const raw = localStorage.getItem(STORAGE_KEY_CAJA_ID);
  const id = Number(raw);
  if (Number.isFinite(id) && id > 0) return id;
  return fallback;
};

